import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { PropertyTenant, PropertyUnit } from '@modules/projects/details/leases/tenants.types';

@Injectable({ providedIn: 'root' })
export class PropertyTenantService extends BaseService {
  constructor(protected readonly httpClient: HttpClient) {
    super(httpClient);
  }

  search(
    propertyId: number,
    sort = { sort: 'unit_number', order: 'asc' },
    maxPageSize = 150,
  ): Observable<PropertyTenant[]> {
    return this.httpClient
      .get<any>(`properties/${propertyId}/property_units?sort=${sort.sort}&order=${sort.order}&per_page=${maxPageSize}`)
      .pipe(
        map(({ property_units }: { property_units: PropertyUnit[] }) => {
          const data = property_units.reduce((p, c) => {
            return [...p, ...(c.property_tenants ?? [])];
          }, [] as PropertyTenant[]);

          return data;
        }),
      );
  }
}
